export * from "./SyllabusCard"
